import { render, staticRenderFns } from "./AJourney.vue?vue&type=template&id=314c2888&scoped=true&"
import script from "./AJourney.vue?vue&type=script&lang=js&"
export * from "./AJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314c2888",
  null
  
)

export default component.exports